<template>
  <section class="container mx-auto pb-10 px-3 lg:px-6 pt-5 lg:pt-10 z-10 relative">
    <h3 class="text-xl text-black m2-3">
      {{$t('workshops.redesigned_workshops')}}
    </h3>
    <div class="border-theme_green border-b-8 w-16 mb-3"></div>
    <div class="flex flex-col-reverse lg:flex-row">
      <ul class="w-full lg:w-2/3">
        <li v-for="(j, index) in collection" :key="j.en" :class="[j.bg ? j.bg : 'odd:bg-gray_1', 'flex p-4 flex-col lg:flex-row']">
          <div class="flex-1 lg:self-center">{{j[$i18n.locale]}}</div>
          <div class="flex flex-col">
            <div class=" text-xs lg:text-base">{{$t('workshops.download_materials')}}</div>
            <div class="flex">
              <a :href="(j.enabled.includes('en'))?'https://admin.who-afro-mlm.com/resources/' + j.en + '.zip':'#'" target="_blank" 
              :class="[btnBaseClass, (j.enabled.includes('en')) ? (index < 15) ? btnOrangeClass : btnBlueClass : btnDisabled]"
              >
              <i class="mdi mdi-arrow-down"></i>
              English
              </a>
              <a :href="(j.enabled.includes('fr'))?'https://admin.who-afro-mlm.com/resources/' + j.fr + '.zip':'#'" target="_blank" 
              :class="[btnBaseClass, (j.enabled.includes('fr')) ? (index < 15) ? btnOrangeClass : btnBlueClass : btnDisabled]">
              <i class="mdi mdi-arrow-down"></i>
              Français
              </a>
              <a :href="(j.enabled.includes('pt'))?'https://admin.who-afro-mlm.com/resources/' + j.pt + '.zip':'#'" target="_blank" 
              :class="[btnBaseClass, (j.enabled.includes('pt')) ? (index < 15) ? btnOrangeClass : btnBlueClass : btnDisabled]">
              <i class="mdi mdi-arrow-down"></i>
              Português
              </a>
            </div>
        
          </div>
        </li>
      </ul>
      <div class="lg:hidden">{{$t('workshops.workshops')}}</div>
      <div class="flex flex-col w-full lg:w-1/3 bg-secondary lg:bg-white text-white lg:text-black">
        <div class="flex lg:ml-3 mb-4 w-full items-center" v-for="item of workshops" :key="item.caption">
            <div class="w-24">
                <img :src="item.imgSrc" :alt="item.caption" class="w-24 h-24">
            </div>
            <div class="p-4 w-64">
                {{$t(item.caption)}}
            </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import {getScreenSize} from "../helpers/screens";

export default {
  name: "workshops",

  data() {
    return {
      btnBaseClass: 'lg:px-2 p-1 whitespace-no-wrap mr-2 rounded focus:outline-none focus:shadow-outline text-xs lg:text-base border-2',
      btnOrangeClass: 'border-theme_orange hover:bg-theme_orange hover:text-white text-gray-700',
      btnBlueClass: 'border-theme_green hover:bg-theme_green hover:text-white text-gray-700',
      btnDisabled: 'border-gray-700, text-gray-300',
      collection: [
        {en: "1. The Role of the EPI Manager",fr: "1. Le rôle du responsable de PEV",pt: "1. Papel do Gestor do PAV", enabled: ['en','fr','pt']},
        {en: "2. How to Solve Immunization Problems",fr: "2. Comment résoudre les problèmes de vaccinations",pt: "2. Como Resolver Problemas de Vacinação", enabled: ['en','fr','pt']},
        {en: "3. Planning Immunization Activities",fr: "3. Planification des activités de vaccination",pt: "3. Planificação de Actividades de Vacinação", enabled: ['en','fr','pt']},
        {en: "4. Communications and Community Involvement",fr: "4. Communication et engagement communautaire",pt: "4. Comunicação e Envolvimento da Comunidade", enabled: ['en','fr','pt']},
        {en: "5. Costing and Financing a National Immunization Programme",fr: "5. Calcul des coûts et financement d'un programme national de vaccination",pt: "5. Cálculo de Custos e Financiamento de um Programa Nacional de Vacinação", enabled: ['en','fr','pt']},
        {en: "6. Vaccine Management",fr: "6. Gestion des vaccins",pt: "6. Gestão de Vacinas", enabled: ['en','fr','pt']},
        {en: "7. Cold Chain Management",fr: "7. Gestion de la chaîne du froid",pt: "7. Gestão da Cadeia de Frio", enabled: ['en','fr','pt']},
        {en: "8. Monitoring Immunization System for Action",fr: "8. Suivi d'un système de vaccination en vue d'intervenir",pt: "8. Monitoria do Sistema de Vacinação para Acção", enabled: ['en','fr','pt']},
        {en: "9. Immunization Safety",fr: "9. Sécurité des vaccinations",pt: "9. Segurança de Vacinação", enabled: ['en','fr','pt']},
        {en: "10. New Vaccines Introduction",fr: "10. Introduction de nouveaux vaccins",pt: "10. Introdução de Novas Vacinas", enabled: ['en','fr','pt']},
        {en: "11. How to Plan and Monitor SIAs",fr: "11. Comment planifier et faire le monitorage des AVS",pt: "11. Como Planificar e Monitorar as ASVs", enabled: ['en','fr','pt']},
        {en: "12. How to Conduct Effective Surveillance Against Vaccine Preventable Disease",fr: "12. Comment effectuer une surveillance efficace des maladies évitables par la vaccination",pt: "12. Como Realizar uma Vigilância Efectiva Contra Doenças Preveníveis por Vacinas", enabled: ['en','fr','pt']},
        {en: "13. Supportive Supvervision",fr: "13. Supervision formative",pt: "13. Supervisão de Apoio", enabled: ['en','fr','pt']},
        {en: "14. Conducting a Review of the Immunization Program",fr: "14. Effectuer une revue du programme de vaccination",pt: "14. Realização de uma Revisão do programa de Vacinação", enabled: ['en','fr','pt']},
        {en: "15. 2YL and Beyond",fr: "15.  À 2 ans (2YL) et au-delà",pt: "15. 2YL and Beyond", enabled: ['en','fr']},
        {bg: "border border-gray_2 bg-white mt-2", en: "EPI Change Management Workshop",fr: "EPI Change Management Workshop",pt: "EPI Change Management Workshop", enabled: ['en']},
        {bg: "border border-gray_2 bg-white mt-2", en: "Becoming an MLM Master Facilitator",fr: "Devenir un Maître formateur MLM",pt: "Becoming an MLM Master Facilitator", enabled: ['en','fr']},
      ],
      workshops: [
      {
        imgSrc: require("../assets/icon-01-17.svg"),
        caption: "workshops.number_workshops",
      },
      {
        imgSrc: require("../assets/icon-02-guides.svg"),
        caption: "workshops.guides",
      },
      {
        imgSrc: require("../assets/icon-03-minute.svg"),
        caption: "workshops.instructions",
      },
      {
        imgSrc: require("../assets/icon-04-exercises.svg"),
        caption: "workshops.specific_points",
      },
      {
        imgSrc: require("../assets/icon-05-pedagogy.svg"),
        caption: "workshops.structured_pedagogy",
      },
    ],

    };
  },

  computed: {
    screenSize() {
      return getScreenSize()
    },
  }
};
</script>

